import React from 'react';

import messages from '../messages';
import TableLevel from './TableLevelListItem';
import TableGroup from './TableGroupListItem';
import Table from './TableListItem';
import symbols from './symbols';
import './TOCList.scss';

function tableNumber(...args) {
	return Array.prototype.join.call(args, '.') + '.';
}

function compareByTableNumber(a, b) {
	if (a.themeSerial < b.themeSerial) {
		return -1;
	} else if (a.themeSerial > b.themeSerial) {
		return 1;
	} else if (a.periodicitySerial < b.periodicitySerial) {
		return -1;
	} else if (a.periodicitySerial > b.periodicitySerial) {
		return 1;
	} else if (a.territorySerial < b.territorySerial) {
		return -1;
	} else if (a.territorySerial > b.territorySerial) {
		return 1;
	} else if (a.tableSerial < b.tableSerial) {
		return -1;
	} else if (a.tableSerial > b.tableSerial) {
		return 1;
	}
	return 0;
}

function renderTOC(tables, lang, frList) {
	const nodes = [];

	const trans = messages[lang];

	let l2 = 0; // level 2 of the toc
	let l3 = 0; // level 3 of the toc
	let g = '';

	let odd = false;

	const sortedTables = [...tables];
	sortedTables.sort(compareByTableNumber);

	// Ez a frCmp map majd segít sorbarendezni a gyorstájék szimbólumokat a táblákon.
	const frCmp = {};
	let i = 0;
	for (const fr of frList) {
		frCmp[fr] = i++;
	}

	for (const table of sortedTables) {
		if (l2 !== table.periodicitySerial) {
			l2 = table.periodicitySerial;
			const l2n = tableNumber(table.themeSerial, l2)
			nodes.push(<TableLevel key={l2n} number={l2n} title={trans.idoszak[l2]} />);
			odd = false;
		}

		if (l3 !== table.territorySerial) {
			l3 = table.territorySerial;
			const l3n = tableNumber(table.themeSerial, l2, l3);
			nodes.push(<TableLevel key={l3n} number={l3n} title={trans.terulet[l3]} />);
			odd = false;
		}

		if (g !== table.translations[lang].topic) {
			g = table.translations[lang].topic;
			if (g) {
				nodes.push(<TableGroup key={'' + l2 + l3 + g} title={g} />);
				odd = false;
			}
		}

		const frSymbols = table.relatedFirstReleases.map(x => ({
			symbol: frCmp[x],
			name: messages[lang].firstReleases[x],
		}));
		frSymbols.sort((a, b) => a.symbol - b.symbol);

		nodes.push(<Table key={table.id} odd={odd = !odd} lang={lang} table={table} frSymbols={frSymbols}></Table>);
	}

	if (nodes.length === 0) {
		nodes.push(
			<tr key='no-tables-to-show'>
				<td colSpan='2'>
					<h3 style={{ textAlign: 'center', paddingTop: '50px' }}>{messages[lang].noTablesToShow}</h3>
				</td>
			</tr>
		);
	}

	return nodes;
}

function getUsedFirstReleaseTags(tables) {
	const symbolSet = {};
	for (let t of tables) {
		for (const fr of t.relatedFirstReleases) {
			if (!symbolSet[fr]) {
				symbolSet[fr] = true;
			}
		}
	}
	return Object.keys(symbolSet);
}

const mgh = "aáeéiíoóöőuúüű".split("");
const aaz = szo => mgh.includes(szo.substring(0, 1).toLowerCase()) ? "az" : "a";
const AAz = szo => mgh.includes(szo.substring(0, 1).toLowerCase()) ? "Az" : "A";

export default function TOCList({ tables, header, lang, showRelatedFirstReleases = false }) {
	const frList = showRelatedFirstReleases ? getUsedFirstReleaseTags(tables) : [];
	frList.sort((a, b) => (messages[lang].firstReleases[a] || '???').localeCompare(messages[lang].firstReleases[b] || '???'));

	return (
		<div>
			{ frList.length > 0
				? <ul className='relatedFirstReleases'>
					{frList.map((x, i) => (
						<li key={x}>
							<span className="symbol" dangerouslySetInnerHTML={{ __html: symbols[i] }}></span>
							{
								messages[lang].relatedFirstReleaseItem
									.replace('%title%', messages[lang].firstReleases[x])
									.replace('%aaz-title%', aaz(messages[lang].firstReleases[x]))
									.replace('%AAz-title%', AAz(messages[lang].firstReleases[x]))
							}
						</li>
					))}
				</ul>
				: null}
			{ header || null }
			<table className='overflow'>
				<tbody>
					{renderTOC(tables, lang, frList)}
				</tbody>
			</table>
		</div>
	);
}
